import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { createRoot } from "react-dom/client";
import "./newIndex.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import userReducer from "./components/features/user/user";
import globalModalReducer from "./components/features/modal/modal";
import campaignReducer from "./components/features/campaign/campaign";
import accountReducer from "./components/features/account/account";
import globalErrorMessageReducer from "./components/features/error-message/errorMessage";
import dashboardReducer from "./components/features/dashboard/dashboard";
import settingsOverlayReducer from "./components/features/settings-overlay/settingsOverlay";
import virtualNumberReducer from "./components/features/virtual-number/virtualNumber";
import globalDialerReducer from "./components/features/dialer/dialer";
import navbarPathsReducer from "./components/features/navbar/navbarPaths";
import globalSearchQueryReducer from "./components/features/search-query/searchQuery";
import usersReducer from "./components/features/users/users";
import calendarReducer from "./components/features/calendar/calendar";
import globalStatusReducer from "./components/features/status/status";
import globalAutodialReducer from "./components/features/autodial/autodial";
import authReducer from "./components/features/permission/permission";
import TagManager from "react-gtm-module";
import appReducer from "./components/features/app/app";
import whatsappBusinessReducer from "./components/features/whatsapp-business/whatsappBusiness";
import whatsappChatReducer from "./components/features/whatsapp-chat/whatsappChat";
import whatsappContactsReducer from "./components/features/whatsapp-contacts/whatsappContacts";
import locationsReducer from "./components/features/locations/locations";

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#34CB65",
          },
          "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e4e4e7",
          },
          "&.Mui-disabled": {
            cursor: "not-allowed",
          },
          '&.Mui-disabled:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e4e4e7',
          },
          '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e4e4e7',
          },
        },
        input: {
          "&::placeholder": {
            fontSize: "14px",
            color: "#A0A0AB",
            fontWeight: 400,
          },
        },
      },
    },
  },
});

export const store = configureStore({
  reducer: {
    app: appReducer,
    whatsappBusiness: whatsappBusinessReducer,
    locations: locationsReducer,
    whatsappChat: whatsappChatReducer,
    whatsappContacts: whatsappContactsReducer,
    auth: authReducer,
    user: userReducer,
    globalModal: globalModalReducer,
    campaignReducer,
    account: accountReducer,
    dashboard: dashboardReducer,
    globalErrorMessage: globalErrorMessageReducer,
    settingsOverlay: settingsOverlayReducer,
    virtualNumber: virtualNumberReducer,
    globalDialer: globalDialerReducer,
    globalSearchQuery: globalSearchQueryReducer,
    usersReducer,
    globalCalendar: calendarReducer,
    globalStatus: globalStatusReducer,
    autodial: globalAutodialReducer,
    navbarPaths: navbarPathsReducer,
  },
});

const container = document.getElementById("root");
const root = createRoot(container);

if (process.env.REACT_APP_GTM_ID) {
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID,
  });
}

// Register service worker for FCM
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("SW registered for FCM:", registration);
    })
    .catch((err) => {
      console.error("SW registration failed:", err);
    });
}

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </Provider>
);
{
  /* <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
</React.StrictMode> */
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// serviceWorker.register()
